export default "__VITE_ASSET__DsxVdZ94__";